import { getTaskSelectAnalyticsEvent } from '@/features/tasks/taskCardCta'
import { pushDataLayerEvent } from '@/lib/analytics/dataLayer'
import { markTaskListNavigation } from '@/lib/productAnalytics'

import type { TaskCardDemoRow } from '../TasksTaskCards/tasksTaskCards.constants'

export function trackTaskFeedCardClick(row: TaskCardDemoRow) {
  const eventName = getTaskSelectAnalyticsEvent(row.cta)
  if (eventName) {
    pushDataLayerEvent({
      event: eventName,
      task_id: row.id,
      task_name: row.apiTitle ?? String(row.title)
    })
  }
  if (row.cta !== 'action') {
    markTaskListNavigation()
  }
}
